import React from 'react';
import isNil from 'lodash/isNil';
import { NumberInput, useResourceContext } from 'react-admin';
import useCheckAccess from 'hooks/useCheckAccess';
import { getInheritedValue } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { MARKUP_APPLICABLE_LEVELS } from '../../constants/tax-classification';

type Props = {
  source: string;
  field: string;
  label: string;
  inheritedSettings: Record<string, any>;
  parentSettings: Record<string, any>;
  taxClassification: string;
};

const formatMarkup = (value: unknown): string => {
  if (isNil(value) || value === '' || !Number.isFinite(Number(value))) {
    return '';
  }
  const decimals = String(value).split('.')[1] ?? '';
  return decimals.length >= 2 ? String(value) : Number(value).toFixed(2);
};

export const MarkupInput = ({
  source,
  field,
  label,
  inheritedSettings,
  taxClassification,
  parentSettings,
}: Props) => {
  const resource = useResourceContext();
  const checkAccess = useCheckAccess();
  const isMarkupApplicable = MARKUP_APPLICABLE_LEVELS.includes(resource);
  const editable = isMarkupApplicable && checkAccess('update', resource, field);
  const helperText = formatMarkup(
    getInheritedValue(inheritedSettings, `${taxClassification}.${field}`, parentSettings),
  );

  return (
    <NumberInput
      source={`${source}.${field}`}
      label={label}
      disabled={!editable}
      helperText={helperText}
    />
  );
};
